import domReady from '@wordpress/dom-ready';
import animate from "./animate";
import "../scss/main.scss";
import galleryToggle from "./gallery-toggle";

// boom
domReady( () => {
    animate();
    galleryToggle();
} );
